<mulo-animated-checkmark [animate]="showAnimation"></mulo-animated-checkmark>
<span class="message semibold">{{ data.message | translate }}</span>
